import {
  CBadge,
  CCol,
  CContainer,
  CForm,
  CFormTextarea,
  CRow,
} from "@coreui/react";
import React, { useState, useEffect } from "react";
import "./QuizComponent.css";
import postApiCall from "src/server/postApiCall";

function TextAnswer({
  type,
  num,
  question,
  score,
  onAnswerChange,
  questionID,
  questionTypeID,
  trainingId1,
  assessmentId,
  valueReset,
  isCorrect,
  correctAnswer, 
  userAnswer,
  isReviewLoaded, 
  currentPage,
  isQuestionsFetched
}) {
  // Use questionID in the state key to ensure unique state for each question
  const [value, setValue] = useState("");

  useEffect(() => {
    // Reset value when questionID changes or valueReset is triggered
    setValue("");
  }, [questionID, valueReset]);

  const handleSelectAnswer = (newValue) => {
    setValue(newValue);
    onAnswerChange(questionID, questionTypeID, newValue);
  };

  const getClassName = () => {
    if (isCorrect === 1) {
      return "reviewAnswers";
    } else if (isCorrect === 0) {
      return "reviewAnswers2";
    }
    return "";
  };

  const addAnswer = async (value) => {
    const requestData = {
      courseId: parseInt(trainingId1),
      assessmentId: parseInt(assessmentId),
      questionId: questionID,
      questionTypeId: questionTypeID,
      value: value,
      finalSubmit: 0,
    };
    try {
      const res = await postApiCall("addAssessmentUserAnswers", requestData);
      // Handle response if necessary
    } catch (err) {
      console.error("Error submitting answer:", err);
    }
  };
  const isDisabled = type === "review";

  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="justify-content-between">
          <CCol>
            <CForm>
              <div>
                <span>
                  <span style={{fontWeight: '650'}}>{`Q${isQuestionsFetched ? currentPage : num + 1})`}</span>{' '}
                  <span style={{fontWeight: '650'}}>
                    {question}
                  </span>
                </span>
                <CCol xs={8}>
                  <CFormTextarea
                    className={getClassName()}
                    // disabled={type === "3" ? false : true}// Always disabled for review
                    disabled={isDisabled}
                    id="exampleFormControlTextarea1"
                    rows={3}
  
                    onChange={(e) => {
                      handleSelectAnswer(e.target.value);
                      setValue(e.target.value);
                     }}
                     value={isReviewLoaded ? userAnswer : value}
                  />
                  {isReviewLoaded && <p style={{marginTop:"10px"}}>Correct Answer: {correctAnswer}</p>} {/* Conditionally display correctAnswer */}
                </CCol>
              </div>
            </CForm>
          </CCol>
          <CCol className="align-self-start" xs={2} md={1}>
            <div className="text-center">
              <h2>
                <CBadge title="Score per question" shape="rounded-pill" color="primary">
                  {score}
                </CBadge>
              </h2>
            </div>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default TextAnswer;
